import type { SVGProps } from "react";
export interface KettleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function KettleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: KettleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m17.5 20.875.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006h-12a1.125 1.125 0 0 1 0-2.25zm-9.049-10.5c1.506 0 2.488.289 3.365.545.833.244 1.561.456 2.733.456a9.2 9.2 0 0 0 2.643-.374 1.124 1.124 0 0 1 .67 2.147c-.524.164-1.73.477-3.313.477-1.506 0-2.487-.29-3.364-.547-.833-.244-1.562-.454-2.734-.454a9.2 9.2 0 0 0-2.632.37 1.126 1.126 0 0 1-.665-2.15c.53-.164 1.73-.47 3.297-.47"
      />
      <path
        fill={color}
        d="M6.733 10.423q.014.173-.028.347l-.412 5.16a.876.876 0 0 0 .873.945h8.668c.51 0 .912-.436.872-.944l-.745-9.306H7.038zm14.142 4.076v-6c0-1.035-.84-1.874-1.875-1.874h-.781l.73 9.126a3.125 3.125 0 0 1-3.115 3.374H7.166a3.126 3.126 0 0 1-3.115-3.374l.363-4.56C3.4 10.69 2.564 10.056 1.958 9.22 1.195 8.17.875 6.92.875 5.5c0-.62.504-1.124 1.125-1.124h3.333l.007-.014a8 8 0 0 1 1.115-1.406C7.487 1.922 9.134.875 11.499.875c2.366 0 4.014 1.047 5.047 2.08a7.8 7.8 0 0 1 1.113 1.406l.008.014h1.332A4.125 4.125 0 0 1 23.126 8.5v6a1.125 1.125 0 0 1-2.25 0ZM3.232 6.625c.107.51.294.924.546 1.272.208.286.48.555.835.809l.169-2.081zm8.267-3.5c-1.5 0-2.552.597-3.269 1.25h6.539c-.717-.653-1.768-1.25-3.27-1.25"
      />
    </svg>
  );
}
